export const SOFTLINE_API_CLAIM_REPORT_BASE = '/complaint-service';

export const SOFTLINE_API_CLAIM_REPORT_CREATE = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint`;

export const SOFTLINE_API_CLAIM_REPORT_FINALIZE = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/{{id}}/finalize`;

export const SOFTLINE_API_CLAIM_REPORT_SIGNATURE = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/{{id}}/signatures/{{role}}`;

export const SOFTLINE_API_CLAIM_REPORT_BY_ID = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/{{id}}`;

export const SOFTLINE_API_CLAIM_REPORT_BY_WORKFLOW = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/workflow/{{workflowId}}`;

export const SOFTLINE_API_CLAIM_REPORT_ITEMS = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/{{id}}/items`;

export const SOFTLINE_API_CLAIM_REPORT_CHECKPOINTS = `${SOFTLINE_API_CLAIM_REPORT_BASE}/complaint/{{id}}/checkpoints`;

export const SOFTLINE_API_MAIL_SEND = '/mail-service/mails/send';

export const SOFTLINE_API_CLAIM_REPORT_DOCUMENT_QUERY =
  '/document-query-service/document/query/{{documentType}}';
